<template lang="pug">
    div
        //LoadingDialog(:loading="loadingData")
        //CrudForm(
            v-if="!loadingData"
            v-bind="staticData"
            :fields="formFields"
            :customRules="customRules"
            @submitForm="handleSubmit($event)"
            :editable="$can('EDIT_SALE_CUSTOMER')"
            :readOnly="!$can('EDIT_SALE_CUSTOMER')"
            :noButtons="!$can('EDIT_SALE_CUSTOMER')"
            )
        model-form(
            ref="fCustomerInfo"
            submit-text="guardar"
            v-bind="formProps"
            v-model="formData"
            @submit="handleSubmit"
            )
            branch-offices-list(
                :items="listItems"
                @success="refresh()"
                v-if="$can('EDIT_SALE_CUSTOMER')"
                slot="append"
                )
</template>

<script>
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import CommuneService from '@/services/api/commune/CommuneService'
import CustomerService from '@/services/api/customer/CustomerService'
//-
import FieldsDetails from './FieldsDetails'
//
import { BranchOfficesList } from '@/components/lists'
import SnackbarModalUtils from '../../mixins/reusable_mixins/SnackbarModalUtils'
import GirosMdl  from '@/models/General/GCoreBusinessSii'
//-
export default {
    components: {
        BranchOfficesList,
        ModelForm,
    },
    name: 'component-name',
    props: {},
    data: function() {
        return {
            formData: {},
            //formFields: fieldComputed,
            listItems: [],
            //titulo
            staticData: null,

            customRules: {
                minLength8: function(value) {
                    return value.length >= 8 ? true : 'El largo mínimo es 8'
                },
            },
            allGiros:[],

            // arrCommunes: null,
            // loadingData:true,
        }
    },
    computed: {
        fieldComputed(){
            return FieldsDetails(this.allGiros)
        },
        //-
        formProps() {
            return {
                fields: this.fieldComputed,
                editable: !this.$can('EDIT_SALE_CUSTOMER'),
                switchEdit: this.$can('EDIT_SALE_CUSTOMER'),
                readOnly: !this.$can('EDIT_SALE_CUSTOMER'),
            }
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        async handleSubmit(event) {
            this.formData = event
            await this.sendUpdateCustomer(this.formData)
        },
        async sendUpdateCustomer(data) {
            //console.log(data, 'before send update')
            data.email_collection = this.checkEmail(data)
            if(data.core_business.length>0 ){
                if(typeof data.core_business[0] === 'object'){
                    data.core_business = data.core_business.map(c=>c.id)
                }
                
            }
            let response = await CustomerService.updateCustomer(
                this.$route.params.id,
                {
                    ...data,
                    branch_offices: this.listItems,
                }
            )
            let resp = await CustomerService.createCustomerCharge(
                this.createObjectCharge(this.$route.params.id, data)
            )
            //
            this.snackResponseSubmit(
                response,
                'El cliente fue editado exitosamente',
                '/customers'
            )
        },
        fillStaticFormData() {
            let information = {}
            information.toolbarTitle = 'Cliente'
            information.toolbarIcon = 'close'
            information.customRules = function(value) {
                return value.length >= 8 ? true : 'El largo mínimo es 8'
            }
            information.editable = true
            information.disabled = false
            information.submitText = 'Editar Cliente'

            return information
        },
        setFormData: function(model) {
             
            this.formData = {...model}
            this.formData.core_business = model.g_core_business_sii
            
            this.formData.charge = (model.sl_customer_presets_charge ) ? parseInt(model.sl_customer_presets_charge.charge_percentage) : 0
            this.listItems = model.branch_offices
            this.listItems = [...this.listItems]
        },
        async fillFields() {
            CustomerService.fetchCustomer(this.$route.params.id).then(
                this.setFormData
            )
        },
        async refresh() {
            //
            this.fillFields()
        },
        /*
         */
        createObjectCharge(id, data) {
            let obj = {}
            obj.sl_customer_id = id
            obj.charge = data.charge
            return obj
        },
        /*
         */
        setLoading(val) {
            this.loadingData = val
        },
        /*
         */
        checkEmail(data){
            if(data.email_collection === '') return  'clientefactura@agroplastic.cl'
            else return data.email_collection 
        },
        async fetchGiros(){
            let giros = await GirosMdl.params({get_all_results:true}).get()
            if(giros.data){
                this.allGiros =giros.data
            }
        }
    },
    watch: {},
    // mixins: [InputValidations, CurrencyUtils,SnackbarModalUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: async function() {
        this.fetchGiros()
        this.staticData = this.fillStaticFormData()
        this.fillFields()
        this.setTitleTopBar('Detalle del cliente')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_SALE_CUSTOMER')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
